import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { InventoryList } from '../components/InventoryList';
import { Alerts } from '../components/AlertsComponent';

export function InventoryPage() {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="inventory" className="space-y-6">
        <TabsList>
          <TabsTrigger value="inventory">Inventory</TabsTrigger>
          <TabsTrigger value="alerts">Inventory Alerts</TabsTrigger>
        </TabsList>

        <TabsContent value="inventory">
          <InventoryList />
        </TabsContent>

        <TabsContent value="alerts">
          <Alerts mode="inventory" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
